import { registerPlugin } from '@capacitor/core';
const BluetoothCommunication = registerPlugin('BluetoothCommunication', {
    web: () => import('./web').then((m) => new m.BluetoothCommunicationWeb()),
});
export * from './definitions';
export { BluetoothCommunication };
//# sourceMappingURL=index.js.map